import Link from "next/link";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ResponsiveShopBanner = ({ banner }) => {
  const desktopImage = banner.images?.desktop;
  const tabletImage = banner.images?.tablet;
  const mobileImage = banner.images?.mobile;

  const link = banner.url;

  const hasImage = desktopImage || tabletImage || mobileImage;

  if (!hasImage) {
    return null;
  }

  if (link) {
    return (
      <Link href={link}>
        <a title="">
          {mobileImage && (
            <img
              src={`${settings.cdn}${mobileImage}`}
              className="w-full sm:hidden"
              alt=""
            />
          )}

          {tabletImage && (
            <img
              src={`${settings.cdn}${tabletImage}`}
              className="w-full hidden sm:block lg:hidden"
              alt=""
            />
          )}

          {desktopImage && (
            <img
              src={`${settings.cdn}${desktopImage}`}
              className="w-full hidden lg:block"
              alt=""
            />
          )}
        </a>
      </Link>
    );
  }

  return (
    <>
      {mobileImage && (
        <img
          src={`${settings.cdn}${mobileImage}`}
          className="w-full sm:hidden"
          alt=""
        />
      )}

      {tabletImage && (
        <img
          src={`${settings.cdn}${tabletImage}`}
          className="w-full hidden sm:block lg:hidden"
          alt=""
        />
      )}

      {desktopImage && (
        <img
          src={`${settings.cdn}${desktopImage}`}
          className="w-full hidden lg:block"
          alt=""
        />
      )}
    </>
  );
};

export default ResponsiveShopBanner;
